import { render, staticRenderFns } from "./Prestador.vue?vue&type=template&id=c6260fbe"
import script from "./Prestador.vue?vue&type=script&lang=js"
export * from "./Prestador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports